import { render, staticRenderFns } from "./ContractTax.vue?vue&type=template&id=4932d9ac&"
import script from "./ContractTax.vue?vue&type=script&lang=js&"
export * from "./ContractTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports